import React from "react";
import {Business, CurrentUser, UserCard, UserType} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router";
import OfferList from "../../components/offer/OfferList";
import {getLocation} from "../../utils/Utils";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  userCardsMap: Map<string, UserCard>;
}

function OffersPage(props: Props) {
  const navigate = useNavigate();
  const cards = Array.from(props.userCardsMap.values())
      .filter(card => card.status == "ACTIVE")
      .sort((a, b) => a.points - b.points);

  return (
      <>
        <AuthCheck />
        <div>
          {props.currentUser.userType == UserType.LOCATION_MANAGER && <div>
              <div className={"primary-button pe-2 mb-3"} onClick={() => navigate("/offers/create")}>
                  Create Offer
                  <div className={"d-inline-block ms-2"}>
                      <FontAwesomeIcon icon={faPlus}/>
                  </div>
              </div>
          </div>}

          {(props.currentUser.userType == UserType.CUSTOMER && cards.length === 0) && <div className={"basic-box mb-0 left-align"}>Visit a location to create your first card.</div>}

          {props.currentUser.userType == UserType.CUSTOMER && cards.map((card) => (
              <>
                {<OfferList
                    currentUser={props.currentUser}
                    location={undefined}
                    business={props.businessMap.get(card.business)?.id}
                    businessMap={props.businessMap}
                    displayTitle={props.currentUser.userType == UserType.CUSTOMER ? props.businessMap.get(card.business)?.name : ""}
                    defaultDisplayList={true}
                    pointsCard={props.userCardsMap.get(card.business)}
                />}
              </>
          ))}

          {props.currentUser.userType == UserType.LOCATION_MANAGER &&
              <OfferList
                  currentUser={props.currentUser}
                  location={getLocation(props.currentUser.business, props.businessMap)}
                  business={undefined}
                  businessMap={props.businessMap}
                  displayTitle={""}
                  defaultDisplayList={true}
                  pointsCard={undefined}
              />
          }

        </div>
      </>
  );
}

export default OffersPage;
